import { getModeledArenas as getStoreItems } from 'selectors'
import { useSelector } from 'react-redux'
import { arenas as fixtures } from '@fedsim/imports'

import { mapImported } from '../helpers'

export function useArenas () {
  const imported = useSelector(getStoreItems)
  const mapped = mapImported(fixtures, imported)
  const notImported = mapped?.filter(item => item.imported === false)

  return { mapped, fixtures, notImported, imported }
}
